const createSeasonsStore = (set) => ({
  seasonsList: undefined,
  isLoading: false,

  setSeasons: (seasons) =>
    set((state) => ({
      superadmin: {
        ...state.superadmin,
        seasons: {
          ...state.superadmin.seasons,
          seasonsList: seasons,
        },
      },
    })),

  setLoading: (isLoading) =>
    set((state) => ({
      superadmin: {
        ...state.superadmin,
        seasons: {
          ...state.superadmin.seasons,
          isLoading,
        },
      },
    })),

  // Reset store to initial state
  reset: () =>
    set((state) => ({
      superadmin: {
        ...state.superadmin,
        seasons: {
          seasonsList: [],
          isLoading: false,
        },
      },
    })),
});

export default createSeasonsStore;
